import React from "react";

export default function SectionLabel({ label }) {
  return (
    <div className="text-center bg-red py-4">
      <p className="text-white text-lg font-bold uppercase">{label}</p>
    </div>
  );
}
